import React from 'react'
import DocumentTitle from 'components/TopLevel/DocumentTitle';

import config from 'Config'
import { SoloPanel } from 'components/Panels'


export default function UsernameError() {
  return (
    <SoloPanel grid={8}>
      <DocumentTitle title="Adafruit IO - Username Error" />

      <h1>Oh no!</h1>

      <p>
        It looks like your account doesn't have a username setup. You won't
        be able to use Adafruit IO until you've created a username. Go
        to <a href={config.accountsUrl}>your account settings page</a> to create a username.
      </p>

      <p>
        <a href={config.accountsUrl} className='btn btn-large blue center'>Update Account Settings</a>
      </p>
    </SoloPanel>
  )
}
